/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementViewItemResponse } from './StoreManagementViewItemResponse';

export type StoreManagementViewItemResponseApiRespoonse = {
    data?: StoreManagementViewItemResponse;
    status?: StoreManagementViewItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementViewItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

